module.exports = __webpack_public_path__ + "img/designedbylibre.6b03739b.png";